import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";

import classes from "../../PublicationListSelectionSlide.module.scss";
import { Domain } from "../../../../../types/campaignTypes";

type DomainListProps = {
  domainList: Domain[];
};

const DomainList: FC<DomainListProps> = ({ domainList }) => {
  return (
    <div className={classes.domainList}>
      {domainList.map(({ domain, brandgenItemId }, index) => (
        <Typography key={brandgenItemId} className={classes.domainList}>
          <a href={`https://${domain}`} target="_blank" rel="noopener noreferrer">
            {domain}
          </a>
          {index === domainList.length - 1 ? "" : ","}
        </Typography>
      ))}
    </div>
  );
};

export default DomainList;
